module.exports = __webpack_public_path__ + "static/media/collector.5a213494.png";